module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/ethereum.c1129ca6-fe7972fdd75547fbe9e39ec880073cd7.png";